const Validator = {
    start: (...elements) => {
        let counter = 0
        elements.forEach(element => {
            if (element == null) {
                counter++
            }
            else {
                if (element instanceof Array) {
                    if (element.length == 0) {
                        counter++
                    }
                }
                else if (element instanceof String) {
                    if (element == undefined || element == null || element == "") {
                        counter++
                    }
                }
                else {
                    if (element == undefined || element == null) {
                        counter++
                    }
                }
            }
        })
        return counter == 0
    },

    isNull(value) {
        return value == null
    },

    isNotNull(value) {
        return value != null
    },

    isNotEmpty(value) {
        if (!this.isNotNull(value)) return false
        return value.length != 0
    },

    isEmpty(element) {
        if (element instanceof Array) {
            if (this.isNull(element)) return
            return element.length == 0
        }
        if (element instanceof String) {
            if (this.isNull(element)) return
            return element == ""
        }
    },

    isNotEmpty(element) {
        if (element instanceof Array) {
            if (this.isNull(element)) return
            return element.length != 0
        }
        if (element instanceof String) {
            if (this.isNull(element)) return
            return element != ""
        }
    }

}

export default Validator